var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.17,248.5a21.85,21.85,0,0,1,5.82-.11l3-4.46,8.32,3.27-.82,5.34a21.69,21.69,0,0,1,4.19,4l5.3-1,3.57,8.19L182.24,267a21.92,21.92,0,0,1,.1,5.83l4.46,3-3.27,8.31-5.34-.82a21.36,21.36,0,0,1-4,4.19l1,5.31L167,296.38,163.77,292a21.51,21.51,0,0,1-5.83.1l-3,4.47-8.31-3.28.82-5.33a22,22,0,0,1-4.19-4.05l-5.3,1-3.57-8.19,4.35-3.2a22.27,22.27,0,0,1-.1-5.82l-4.46-3,3.27-8.31,5.34.81a21.93,21.93,0,0,1,4-4.19l-1-5.3,8.2-3.57,3.19,4.36ZM157,261.31a9.59,9.59,0,1,0,12.61,5A9.59,9.59,0,0,0,157,261.31Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8,339.5a23.29,23.29,0,0,1,6.18-.1l3.22-4.74L62,338.13l-.87,5.66a23.15,23.15,0,0,1,4.45,4.29L71.21,347,75,355.7l-4.62,3.38a22.8,22.8,0,0,1,.11,6.17l4.73,3.23-3.47,8.81-5.65-.87a23.46,23.46,0,0,1-4.29,4.45l1.07,5.62-8.69,3.78-3.38-4.62a22.88,22.88,0,0,1-6.18.11l-3.22,4.73L32.59,387l.86-5.66A23.34,23.34,0,0,1,29,377.08l-5.62,1.07-3.78-8.69,4.61-3.39a23.2,23.2,0,0,1-.1-6.17l-4.74-3.22,3.47-8.81,5.66.86a23.39,23.39,0,0,1,4.29-4.44l-1.07-5.62,8.69-3.78,3.38,4.61Zm-.16,13.59A10.16,10.16,0,1,0,57,358.35,10.15,10.15,0,0,0,43.64,353.09Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.05,224.49a23.72,23.72,0,0,1,6.18-.11l3.22-4.73,8.82,3.47-.86,5.66a23.39,23.39,0,0,1,4.44,4.29l5.63-1.07,3.78,8.7-4.61,3.38a23.29,23.29,0,0,1,.1,6.18l4.74,3.23L400,262.31l-5.67-.87a23.15,23.15,0,0,1-4.29,4.45l1.07,5.62-8.69,3.79-3.39-4.62a23.72,23.72,0,0,1-6.18.11l-3.22,4.73-8.82-3.47.87-5.66a23.46,23.46,0,0,1-4.45-4.29l-5.63,1.06-3.78-8.69,4.62-3.39a22.8,22.8,0,0,1-.11-6.17l-4.74-3.23,3.48-8.82,5.66.87a23.15,23.15,0,0,1,4.29-4.45L360,223.66l8.69-3.79,3.39,4.62Zm-.16,13.6a10.17,10.17,0,1,0,13.38,5.27A10.17,10.17,0,0,0,371.89,238.09Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.67,56a36.75,36.75,0,0,1,8.93-3.88l1.84-8.83,14.92-.26,2.15,8.76a36.72,36.72,0,0,1,9.06,3.56l7.55-4.94,10.74,10.37-4.68,7.71a36.53,36.53,0,0,1,3.88,8.93l8.83,1.84.27,14.93-8.77,2.15a36.81,36.81,0,0,1-3.56,9l4.94,7.55L247.4,123.71,239.69,119a36.37,36.37,0,0,1-8.93,3.88l-1.84,8.84L214,132l-2.15-8.77a36.33,36.33,0,0,1-9.06-3.56l-7.55,4.95L184.5,114.25l4.68-7.71a36.37,36.37,0,0,1-3.88-8.93l-8.83-1.83-.27-14.93L185,78.7a36.72,36.72,0,0,1,3.56-9.06l-4.94-7.54L194,51.36,201.67,56Zm8,19.89a16,16,0,1,0,22.65-.4A16,16,0,0,0,209.63,75.92Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.45,42.89a25,25,0,0,1,6-2.66l1.2-6,10.1-.24,1.49,5.91a24.85,24.85,0,0,1,6.14,2.37l5.08-3.38,7.31,7-3.13,5.23a24.66,24.66,0,0,1,2.67,6l6,1.2.25,10.09-5.92,1.5a24.23,24.23,0,0,1-2.37,6.14l3.38,5.08-7,7.31-5.24-3.13a24.59,24.59,0,0,1-6,2.67l-1.21,6-10.09.25-1.49-5.92a24.85,24.85,0,0,1-6.14-2.37l-5.08,3.38-7.31-7,3.12-5.24a24.84,24.84,0,0,1-2.66-6l-6-1.2-.25-10.09,5.92-1.49a24.43,24.43,0,0,1,2.36-6.14l-3.38-5.08,7-7.31,5.23,3.12Zm5.48,13.41a10.83,10.83,0,1,0,15.31-.37A10.82,10.82,0,0,0,131.93,56.3Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.62,116.74a23.36,23.36,0,0,1,5.74-2.5l1.18-5.68,9.59-.17,1.39,5.64a23.34,23.34,0,0,1,5.82,2.29l4.85-3.18,6.9,6.67-3,5a23.66,23.66,0,0,1,2.49,5.74l5.68,1.19.17,9.59-5.64,1.38a23.18,23.18,0,0,1-2.29,5.83l3.18,4.85-6.66,6.9-5-3a23.7,23.7,0,0,1-5.74,2.5l-1.18,5.68-9.6.17-1.38-5.64a23.34,23.34,0,0,1-5.82-2.29l-4.85,3.18-6.91-6.67,3-4.95a23.7,23.7,0,0,1-2.5-5.74l-5.68-1.19-.16-9.59,5.63-1.38a24,24,0,0,1,2.29-5.83L119,120.63l6.67-6.9,5,3Zm5.11,12.78a10.3,10.3,0,1,0,14.56-.26A10.3,10.3,0,0,0,135.73,129.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.76,80.36a11.62,11.62,0,0,1,2.81-1.22l.58-2.78,4.7-.08L87.52,79a12.05,12.05,0,0,1,2.86,1.12l2.37-1.55,3.38,3.26-1.47,2.43a11.85,11.85,0,0,1,1.22,2.81l2.78.58.08,4.69L96,93.05a11.34,11.34,0,0,1-1.12,2.85l1.56,2.38-3.27,3.38-2.42-1.48a11.24,11.24,0,0,1-2.81,1.22l-.58,2.78-4.7.09L82,101.51a11.42,11.42,0,0,1-2.85-1.12l-2.38,1.55-3.38-3.26,1.47-2.43a11.85,11.85,0,0,1-1.22-2.81l-2.78-.57-.08-4.7,2.76-.68a11.34,11.34,0,0,1,1.12-2.85l-1.56-2.37,3.27-3.38,2.42,1.47Zm2.51,6.26a5,5,0,1,0,7.12-.13A5,5,0,0,0,81.27,86.62Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.58,281.85H419.9a1.82,1.82,0,0,0-1.83,1.72l-.38,7.51a1.83,1.83,0,0,0,1.81,1.9l10.08.12Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.82 293.1 442.01 469.56 423.37 469.56 431.42 293.1 439.82 293.1",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "439.82 293.1 440.09 308.02 430.93 300.67 431.42 293.1 439.82 293.1",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.48,284v7.77A1.37,1.37,0,0,1,449,293.1H429.58V281.85l19.53.9A1.36,1.36,0,0,1,450.48,284Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.75,292c1.43,1.24,31.35,43.88,33.8,48.08,2.76,4.72.24,7.6.24,7.6l-49.11-60.45,2.86-3.23,5.88,7.13S434.32,290.8,435.75,292Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.55,340.12a17.47,17.47,0,0,1,1,2l-2.11-2.54-39-48.4s4.9-.37,6.33.87S467.1,335.92,469.55,340.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.91,309.15a6.21,6.21,0,0,0-.73-1l-2.1-2.62-6.89-8.66c-2.69-3.38-5.16-6.43-7-8.58-.92-1.09-1.67-1.95-2.21-2.54a5.68,5.68,0,0,0-.86-.88,6.85,6.85,0,0,0,.74,1l2.09,2.62,6.9,8.66c2.68,3.38,5.15,6.42,7,8.58.92,1.08,1.67,1.95,2.2,2.54A8.17,8.17,0,0,0,443.91,309.15Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.45,296.9c-1.55.87-50.34,12.9-55,13.62-5.26.81-7.44-2.62-7.44-2.62l70.8-23.31,2.43,3.89-8.37,2.83S414,296,412.45,296.9Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.43,310.52a15.52,15.52,0,0,1-2.18.17l3-1,56.6-18.36s-.85,4.72-2.4,5.59S362.11,309.8,357.43,310.52Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.6,288.35a6.82,6.82,0,0,0-1.11.26l-3,.88c-2.55.76-6,1.85-9.88,3.1s-7.3,2.43-9.78,3.34c-1.24.45-2.24.83-2.92,1.11a5.44,5.44,0,0,0-1,.48,5.65,5.65,0,0,0,1.11-.32l3-1,9.82-3.22,9.83-3.22,3-1A4.49,4.49,0,0,0,423.6,288.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.59,268.82c.54-1.75,27.38-44.52,30.23-48.27,3.21-4.23,7-3,7-3l-35.2,66.71-4.21-1.43,4.11-8S422.05,270.57,422.59,268.82Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.82,220.55a15.87,15.87,0,0,1,1.44-1.63l-1.47,2.85L424.48,274.9s-2.43-4.33-1.89-6.08S450,224.3,452.82,220.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.47,280.72c.11,0,3.41-6,7.37-13.46s7.1-13.61,7-13.66-3.41,6-7.38,13.45S421.36,280.66,421.47,280.72Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.35,286.58c0,.81-.75,2.39-.22,2.9s2.34.34,3.26.34a3.24,3.24,0,0,0,0-6.47,10.5,10.5,0,0,0-3.38.24C419.27,283.81,420.35,285.78,420.35,286.58Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.11,286.58a3.06,3.06,0,1,0,3.05-3.23A3.15,3.15,0,0,0,418.11,286.58Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424,283.35a4.17,4.17,0,0,0-1.12-.11l-1.28,0c-.24,0-.51,0-.81,0a3.29,3.29,0,0,0-.9.22h0a3.4,3.4,0,0,0-2,2.84,3.51,3.51,0,0,0,1.06,2.83,3,3,0,0,0,2.44.83h0a10.77,10.77,0,0,0,2-.11,10.57,10.57,0,0,0-2-.16h0a2.7,2.7,0,0,1-2.11-.82,3.16,3.16,0,0,1-.9-2.53,3.07,3.07,0,0,1,1.74-2.55h0a3.32,3.32,0,0,1,.77-.22c.25,0,.51,0,.76,0l1.29,0A4.17,4.17,0,0,0,424,283.35Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.42,289.77a2.07,2.07,0,0,0,1.24-.42,3.54,3.54,0,0,0,1.69-2.44,3.3,3.3,0,0,0-.94-2.74,2,2,0,0,0-1.08-.69s.38.3.83.87a3.36,3.36,0,0,1,.73,2.51,3.55,3.55,0,0,1-1.43,2.26C421.87,289.57,421.39,289.71,421.42,289.77Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.75,289.83a2.24,2.24,0,0,0,1.43-.15,3.74,3.74,0,0,0,2.36-2.29,3.26,3.26,0,0,0-.67-3.06,2.09,2.09,0,0,0-1.13-.8c-.05.06.42.33.87,1a3.26,3.26,0,0,1,.49,2.78,3.68,3.68,0,0,1-2.05,2.13C423.3,289.75,422.74,289.76,422.75,289.83Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.11,374.83h-6.47a1.25,1.25,0,0,0-1.23,1.22l-.25,5.33a1.25,1.25,0,0,0,1.21,1.34l6.74.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.87,388.75c-.15,1.22-13.09,32.77-14.57,35.6-1.67,3.18-4.42,2.79-4.42,2.79l15.59-48.45,3.1.47-1.8,5.76S151,387.52,150.87,388.75Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.3,424.35a10.35,10.35,0,0,1-.78,1.25l.64-2.07,12.61-38.61s2.25,2.6,2.1,3.83S137.78,421.52,136.3,424.35Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.09,380.7c-.14,0-1.67,4.34-3.43,9.78s-3.08,9.88-2.95,9.92,1.67-4.33,3.43-9.77S150.22,380.75,150.09,380.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.98 382.81 163.44 469.85 150.96 469.85 156.35 382.81 161.98 382.81",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "161.98 382.81 162.16 393.39 156.02 388.18 156.35 382.81 161.98 382.81",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.11,376.38v5.52a.94.94,0,0,1-1,.91h-13v-8l13.09.64A.93.93,0,0,1,169.11,376.38Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.63,371.83c-.62-1.09-9.27-34.3-9.78-37.46-.59-3.54,1.87-4.73,1.87-4.73l16.74,48.63-2.79,1.32-2-5.75S143.26,372.93,142.63,371.83Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.85,334.37a11.12,11.12,0,0,1-.13-1.46l.73,2.06,13.19,38.87s-3.38-.91-4-2S133.36,337.53,132.85,334.37Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.74,359.4a20.56,20.56,0,0,0,.87,2.9c.62,1.91,1.41,4.3,2.27,6.94s1.75,5.15,2.42,6.91a17.46,17.46,0,0,0,1.2,2.79,20.56,20.56,0,0,0-.87-2.9c-.62-1.91-1.4-4.3-2.27-6.94s-1.75-5.15-2.42-6.9A16.32,16.32,0,0,0,141.74,359.4Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.61 420.17 154.04 420.17 153.73 425.19 162.69 425.19 162.61 420.17",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "162.72 426.99 153.62 426.99 153.54 428.29 162.74 428.32 162.72 426.99",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.18,380c1.2.5,29.51,21.79,32,24,2.76,2.47,1.63,4.87,1.63,4.87l-44.62-28.76,1.29-2.69,5.32,3.37S160,379.48,161.18,380Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.15,404a10.4,10.4,0,0,1,1,1.08l-1.91-1.2-35.51-23.09s3.22-1.28,4.41-.78S190.69,401.77,193.15,404Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.21,377.23a18.19,18.19,0,0,0,2.44,1.81c1.54,1.08,3.7,2.53,6.12,4.09s4.62,2.95,6.25,3.91a16.89,16.89,0,0,0,2.7,1.45,21.23,21.23,0,0,0-2.51-1.73l-6.17-4c-2.41-1.56-4.6-3-6.2-4A18.67,18.67,0,0,0,151.21,377.23Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.93,378.19c0,.57-.49,1.69-.14,2.05s1.56.24,2.19.24a2.31,2.31,0,0,0,0-4.59,6.84,6.84,0,0,0-2.27.17C148.22,376.22,148.93,377.62,148.93,378.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.44,378.19a2.05,2.05,0,1,0,2-2.3A2.17,2.17,0,0,0,147.44,378.19Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.4,375.89s-.27-.08-.75-.12l-.85,0c-.17,0-.34,0-.56,0a1.83,1.83,0,0,0-.63.16h0a2.5,2.5,0,0,0-1.42,2.08,2.63,2.63,0,0,0,.74,2.07,2,2,0,0,0,1.71.6h0a4.16,4.16,0,0,0,1.36-.14,3.94,3.94,0,0,0-1.33-.18h0a1.68,1.68,0,0,1-1.34-.58,2.27,2.27,0,0,1-.58-1.73,2.13,2.13,0,0,1,1.11-1.74h0a2.12,2.12,0,0,1,1-.17l.86-.05C151.13,376,151.4,375.94,151.4,375.89Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.65,380.45c0,.05.38.05.88-.25a2.5,2.5,0,0,0,1.18-1.77,2.44,2.44,0,0,0-.67-2c-.39-.4-.75-.5-.78-.45s.23.26.5.66a2.46,2.46,0,0,1,.45,1.73,2.59,2.59,0,0,1-.9,1.57C149.94,380.26,149.63,380.38,149.65,380.45Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.54,380.49c0,.06.39.15,1,0a2.65,2.65,0,0,0,1.65-1.66,2.43,2.43,0,0,0-.49-2.23c-.4-.47-.79-.59-.81-.54s.25.27.52.73a2.39,2.39,0,0,1,.29,1.91,2.58,2.58,0,0,1-1.3,1.48C150.9,380.38,150.54,380.42,150.54,380.49Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "226.49 427.71 207.33 427.71 212.36 383.3 221.46 383.3 226.49 427.71",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "210.45 400.15 210.06 403.55 223.76 403.55 223.37 400.15 210.45 400.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "221.8 386.15 221.47 383.3 212.37 383.3 212.05 386.15 221.8 386.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "209.75 406.28 207.33 427.71 226.49 427.71 224.06 406.28 209.75 406.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.88 427.71 228.72 427.71 233.75 383.3 242.85 383.3 247.88 427.71",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.15 406.28 228.72 427.71 247.88 427.71 245.46 406.28 231.15 406.28",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "243.19 386.15 242.87 383.3 233.76 383.3 233.44 386.15 243.19 386.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "231.84 400.15 231.46 403.55 245.15 403.55 244.76 400.15 231.84 400.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 408.88,
    width: 84.45,
    height: 60.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.19,
    y: 422.87,
    width: 75.22,
    height: 46.5,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "214 429.61 195.19 422.87 214 408.88 214 429.61",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.8 429.61 214 422.87 232.8 408.88 232.8 429.61",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "251.61 429.61 232.8 422.87 251.61 408.88 251.61 429.61",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "270.41 429.61 251.61 422.87 270.41 408.88 270.41 429.61",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 195.19,
    y: 446.12,
    width: 75.22,
    height: 23.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.41,
    y: 446.12,
    width: 28.04,
    height: 23.25,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200.65,
    y: 449.21,
    width: 32.15,
    height: 20.15,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.78,
    y: 450.33,
    width: 29.89,
    height: 19.04,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 210.81,
    cy: 439.12,
    r: 4.32,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.35,439.12a3.54,3.54,0,1,1-3.54-3.54A3.54,3.54,0,0,1,214.35,439.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.3,439.65l-3.2-.53a.27.27,0,0,0-.16-.23l1.58-2.85a3.52,3.52,0,0,0-1.71-.46,3.58,3.58,0,0,0-1.69.45l1.56,2.85a.28.28,0,0,0-.18.25h0l-3.18.48a3.49,3.49,0,0,0,2.06,2.73l1.3-3s.07.05.11.05a.26.26,0,0,0,.15-.07l1.27,3A3.55,3.55,0,0,0,214.3,439.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 231.68,
    cy: 439.12,
    r: 4.32,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.18,441.62a3.54,3.54,0,1,1,0-5A3.55,3.55,0,0,1,234.18,441.62Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.77,442l-1.89-2.63a.28.28,0,0,0,.05-.28l3.13-.9a3.4,3.4,0,0,0-2.4-2.41l-.91,3.12a.26.26,0,0,0-.3.05h0L228.85,437a3.54,3.54,0,0,0-.47,3.39l3-1.18a.21.21,0,0,0,0,.12.25.25,0,0,0,.14.06l-1.22,3A3.56,3.56,0,0,0,233.77,442Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.54,
    cy: 439.12,
    r: 4.32,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 252.54,
    cy: 439.12,
    r: 3.54,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.38,437l-2.63,1.89a.28.28,0,0,0-.28-.05l-.9-3.14a3.51,3.51,0,0,0-1.53.89,3.46,3.46,0,0,0-.88,1.52l3.12.9a.27.27,0,0,0,.05.31h0l-1.91,2.59a3.54,3.54,0,0,0,3.39.48l-1.18-3a.61.61,0,0,0,.12,0s0-.09.06-.15l3,1.22A3.54,3.54,0,0,0,255.38,437Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.96,
    y: 450.33,
    width: 29.89,
    height: 2.02,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.96,
    y: 454.58,
    width: 29.89,
    height: 2.02,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.96,
    y: 458.84,
    width: 29.89,
    height: 2.02,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.96,
    y: 463.09,
    width: 29.89,
    height: 2.02,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.96,
    y: 467.35,
    width: 29.89,
    height: 2.02,
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.38,469.85c0,.15-94.2.26-210.37.26S39.62,470,39.62,469.85s94.18-.26,210.39-.26S460.38,469.71,460.38,469.85Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Earth--inject-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M451.47,113.68A68.43,68.43,0,0,1,383,182.11c-17.29,0-33.54-6.06-45.59-16.64-14.29-12.54-22.85-31.28-22.85-51.79a68.44,68.44,0,0,1,136.87,0Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M451.31,119.65c.08-.8.15-1.58.2-2.37s.09-1.67.12-2.5c0,.83-.07,1.66-.12,2.5S451.39,118.85,451.31,119.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.82,152.74c-2.2,2.25-3.14,5.42-4.22,8.4s-2.52,6.07-5.23,7.63-6.94.61-7.65-2.46c-.39-1.67.32-3.41.27-5.12-.07-2.24-1.41-4.22-1.8-6.41a16.52,16.52,0,0,1,.36-5.68c1.72-10.29,1.38-21.45-4-30.3a6.75,6.75,0,0,0-2.56-2.73,3.86,3.86,0,0,0-4.2.6c-.69.63-1.16,1.52-2,2-1.73,1.07-4.08-.4-4.71-2.35s-.07-4.07.49-6c.69-2.45,1.39-4.9,2.08-7.35a6.63,6.63,0,0,1,1.82-3.48c1.47-1.17,3.63-.81,5.31-1.63,2.2-1.09,3-3.82,4.63-5.69s5.57-2,5.66.48c5.72-7.93,12,6.76,17.43,6.83,1.58,0,3.22-.43,4.71.09,2.64.92,3.44,4.24,3.84,7l2,14c.25,1.77.64,3.77,2.13,4.72,1.14.73,2.65.65,3.8,1.35,3.05,1.88.94,7-2.18,8.76s-7.12,2.55-9,5.64c-1.45,2.32-1.27,5.41-2.78,7.69C409,150.36,407.18,151.34,405.82,152.74Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.82,152.74c-2.2,2.25-3.14,5.42-4.22,8.4s-2.52,6.07-5.23,7.63-6.94.61-7.65-2.46c-.39-1.67.32-3.41.27-5.12-.07-2.24-1.41-4.22-1.8-6.41a16.52,16.52,0,0,1,.36-5.68c1.72-10.29,1.38-21.45-4-30.3a6.75,6.75,0,0,0-2.56-2.73,3.86,3.86,0,0,0-4.2.6c-.69.63-1.16,1.52-2,2-1.73,1.07-4.08-.4-4.71-2.35s-.07-4.07.49-6c.69-2.45,1.39-4.9,2.08-7.35a6.63,6.63,0,0,1,1.82-3.48c1.47-1.17,3.63-.81,5.31-1.63,2.2-1.09,3-3.82,4.63-5.69s5.57-2,5.66.48c5.72-7.93,12,6.76,17.43,6.83,1.58,0,3.22-.43,4.71.09,2.64.92,3.44,4.24,3.84,7l2,14c.25,1.77.64,3.77,2.13,4.72,1.14.73,2.65.65,3.8,1.35,3.05,1.88.94,7-2.18,8.76s-7.12,2.55-9,5.64c-1.45,2.32-1.27,5.41-2.78,7.69C409,150.36,407.18,151.34,405.82,152.74Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.76,158.05c-1.11-.06-2.28-.86-3.25-.28a3.68,3.68,0,0,0-1.12,1.59,3.76,3.76,0,0,1-2,1.83,2.29,2.29,0,0,1-2.49-.54,1.78,1.78,0,0,1,.13-2.46c.32-.26.74-.36,1.09-.59,1.71-1.1,1.23-3.86,2.65-5.29.83-.84,2-1.62,2.95-2.47.69-.64,1-1.2,2.05-1.21C422.36,148.62,422.5,158.31,417.76,158.05Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.5,162.66c.49.5,1,1,1.49,1.47.35.34.71.67,1.07,1-.36-.33-.72-.66-1.07-1C335.48,163.65,335,163.16,334.5,162.66Z",
    style: {
      fill: "#263238",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.47,125.55c.19-1,.35-2,.49-3-.14,1-.3,2-.49,3,0,.31-.11.63-.17.94-.3,1.52-.65,3-1,4.48.38-1.48.73-3,1-4.48C450.36,126.18,450.43,125.86,450.47,125.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.81,101.75c.15.93.27,1.87.38,2.8-.11-.93-.23-1.87-.38-2.8,0,0,0,0,0,0h0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.47,125.55c.19-1,.35-2,.49-3s.26-2,.35-2.94c.08-.8.15-1.58.2-2.37s.09-1.67.12-2.5a70.26,70.26,0,0,0-.16-7.41c-.08-1-.17-1.89-.28-2.82s-.23-1.87-.38-2.8h0q-.31-1.06-.72-2.13c-2.54-6.76-7-12.55-10-19.13-1-2.14-1.7-3.89-4-4.73-3.4-1.24-5.58.44-7.39-3.44-.49-1-1.5-2.12-2.59-1.77.11.77.23,1.55.34,2.34a1,1,0,0,1,0,.49c-.15.5-.92.49-1.29.13a4.65,4.65,0,0,1-.7-1.41,3.46,3.46,0,0,0-5-1.42,2,2,0,0,0-.8-1.83,2.35,2.35,0,0,1-3.27,1.33c-.07-.7,1.11-.59,1.63-1.08s.17-1.28-.22-1.82a7.43,7.43,0,0,0-4.26-2.74c-1.07-.24-2.27-.26-3.09-1-.48-.43-.76-1.05-1.25-1.47-1-.92-2.64-.58-4-.15-1.81.6-3.71,1.43-4.65,3.13s-.13,4.37,1.76,4.51a3.68,3.68,0,0,1,1.45.11,1.8,1.8,0,0,1,.68,1.86,5.1,5.1,0,0,0-.09,2.09c.2.67,1.1,1.16,1.59.66,1-.67,1.21-2.11,1.23-3.36s.05-2.64.94-3.49,2.87-.13,2.49,1c-.23.7-1.13,1.06-1.24,1.8s.69,1.3,1.42,1.41A8.2,8.2,0,0,1,412,72c.68.32,1.06,1.37.44,1.8-1.08.84-3-1.35-3.74-.18a3.94,3.94,0,0,0-.24,1c-.29,1-1.68,1.17-2.75,1.1a5.77,5.77,0,0,1-3-.84,2.06,2.06,0,0,1-.54-2.84,1.19,1.19,0,0,0-1.74.28,3.6,3.6,0,0,0-.51,2c-1.06-.47-2.23.29-3.05,1.11s-1.65,1.81-2.79,1.93-2.55-.62-3.31.26c-1,1.15.81,3.22-.19,4.36-.57.64-1.58.42-2.43.49-2.26.19-3.64,3.23-2.52,5.22a4.21,4.21,0,0,0,5.92,1.15c1.29-.91,2-2.39,3.08-3.58s2.75-2.1,4.13-1.38a4.63,4.63,0,0,1,1.33,1.28q.89,1.11,1.77,2.25a2,2,0,0,1,.62,1.66c-.14.48-.58.79-.83,1.21-.71,1.22.9,2.84,2.22,2.35A2.69,2.69,0,0,0,405.08,89c-.8-1.78-3.14-3.05-2.7-5,1.49-.8,3.28.71,3.73,2.36s.11,3.42.43,5.1,1.81,3.4,3.42,2.93c-.11-1.41-.22-2.82-.34-4.23,1.07-.53,1.74,1.76,2.92,1.64.73-.08,1-1.06.84-1.79a10.32,10.32,0,0,1-.56-2.15,2.25,2.25,0,0,1,3-1.78,3.41,3.41,0,0,1,1.93,3.28,6.26,6.26,0,0,0,0,1.62c.28,1.13,1.48,1.7,2.44,2.34s1.84,1.93,1.19,2.9c-.29.43-.86.78-.78,1.29s.65.76.56,1.21c-.07.3-.42.45-.72.51-.76.16-1.54.1-2.29.3a2,2,0,0,0-1.59,1.51c-.13,1.1,1,1.87,1.45,2.89s.1,2.09.27,3.13a10.74,10.74,0,0,0,1.13,2.69c1.28,2.8,1.07,6,1.36,9.11.12,1.38.54,3,1.81,3.49a4,4,0,0,0,2.21,0c2.05-.39,4.19-.82,5.83-2.13s2.61-3.8,1.54-5.61a1.13,1.13,0,0,0-.56-.56,2.1,2.1,0,0,0-1.07.16,2.86,2.86,0,0,1-2.84-1.23,8.52,8.52,0,0,1-1.23-3c-.31-1.17-.62-2.36-.94-3.55a1.88,1.88,0,0,1,2.24.67,12.67,12.67,0,0,1,1.16,2.26c1.19,2.32,3.62,3.73,6.08,4.53a6.29,6.29,0,0,1,1.81.77c1.71,1.25,1.69,4.19,3.56,5.19a12.31,12.31,0,0,1,1.61.72,3.21,3.21,0,0,1,1,2.42,35.25,35.25,0,0,0,.3,5c.35,1.64,1.41,3.28,3,3.62a3.92,3.92,0,0,0,2.94-.69h0c.38-1.48.73-3,1-4.48C450.36,126.18,450.43,125.86,450.47,125.55Z",
    style: {
      fill: "#92E3A9",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.47,125.55c.19-1,.35-2,.49-3s.26-2,.35-2.94c.08-.8.15-1.58.2-2.37s.09-1.67.12-2.5a70.26,70.26,0,0,0-.16-7.41c-.08-1-.17-1.89-.28-2.82s-.23-1.87-.38-2.8h0q-.31-1.06-.72-2.13c-2.54-6.76-7-12.55-10-19.13-1-2.14-1.7-3.89-4-4.73-3.4-1.24-5.58.44-7.39-3.44-.49-1-1.5-2.12-2.59-1.77.11.77.23,1.55.34,2.34a1,1,0,0,1,0,.49c-.15.5-.92.49-1.29.13a4.65,4.65,0,0,1-.7-1.41,3.46,3.46,0,0,0-5-1.42,2,2,0,0,0-.8-1.83,2.35,2.35,0,0,1-3.27,1.33c-.07-.7,1.11-.59,1.63-1.08s.17-1.28-.22-1.82a7.43,7.43,0,0,0-4.26-2.74c-1.07-.24-2.27-.26-3.09-1-.48-.43-.76-1.05-1.25-1.47-1-.92-2.64-.58-4-.15-1.81.6-3.71,1.43-4.65,3.13s-.13,4.37,1.76,4.51a3.68,3.68,0,0,1,1.45.11,1.8,1.8,0,0,1,.68,1.86,5.1,5.1,0,0,0-.09,2.09c.2.67,1.1,1.16,1.59.66,1-.67,1.21-2.11,1.23-3.36s.05-2.64.94-3.49,2.87-.13,2.49,1c-.23.7-1.13,1.06-1.24,1.8s.69,1.3,1.42,1.41A8.2,8.2,0,0,1,412,72c.68.32,1.06,1.37.44,1.8-1.08.84-3-1.35-3.74-.18a3.94,3.94,0,0,0-.24,1c-.29,1-1.68,1.17-2.75,1.1a5.77,5.77,0,0,1-3-.84,2.06,2.06,0,0,1-.54-2.84,1.19,1.19,0,0,0-1.74.28,3.6,3.6,0,0,0-.51,2c-1.06-.47-2.23.29-3.05,1.11s-1.65,1.81-2.79,1.93-2.55-.62-3.31.26c-1,1.15.81,3.22-.19,4.36-.57.64-1.58.42-2.43.49-2.26.19-3.64,3.23-2.52,5.22a4.21,4.21,0,0,0,5.92,1.15c1.29-.91,2-2.39,3.08-3.58s2.75-2.1,4.13-1.38a4.63,4.63,0,0,1,1.33,1.28q.89,1.11,1.77,2.25a2,2,0,0,1,.62,1.66c-.14.48-.58.79-.83,1.21-.71,1.22.9,2.84,2.22,2.35A2.69,2.69,0,0,0,405.08,89c-.8-1.78-3.14-3.05-2.7-5,1.49-.8,3.28.71,3.73,2.36s.11,3.42.43,5.1,1.81,3.4,3.42,2.93c-.11-1.41-.22-2.82-.34-4.23,1.07-.53,1.74,1.76,2.92,1.64.73-.08,1-1.06.84-1.79a10.32,10.32,0,0,1-.56-2.15,2.25,2.25,0,0,1,3-1.78,3.41,3.41,0,0,1,1.93,3.28,6.26,6.26,0,0,0,0,1.62c.28,1.13,1.48,1.7,2.44,2.34s1.84,1.93,1.19,2.9c-.29.43-.86.78-.78,1.29s.65.76.56,1.21c-.07.3-.42.45-.72.51-.76.16-1.54.1-2.29.3a2,2,0,0,0-1.59,1.51c-.13,1.1,1,1.87,1.45,2.89s.1,2.09.27,3.13a10.74,10.74,0,0,0,1.13,2.69c1.28,2.8,1.07,6,1.36,9.11.12,1.38.54,3,1.81,3.49a4,4,0,0,0,2.21,0c2.05-.39,4.19-.82,5.83-2.13s2.61-3.8,1.54-5.61a1.13,1.13,0,0,0-.56-.56,2.1,2.1,0,0,0-1.07.16,2.86,2.86,0,0,1-2.84-1.23,8.52,8.52,0,0,1-1.23-3c-.31-1.17-.62-2.36-.94-3.55a1.88,1.88,0,0,1,2.24.67,12.67,12.67,0,0,1,1.16,2.26c1.19,2.32,3.62,3.73,6.08,4.53a6.29,6.29,0,0,1,1.81.77c1.71,1.25,1.69,4.19,3.56,5.19a12.31,12.31,0,0,1,1.61.72,3.21,3.21,0,0,1,1,2.42,35.25,35.25,0,0,0,.3,5c.35,1.64,1.41,3.28,3,3.62a3.92,3.92,0,0,0,2.94-.69h0c.38-1.48.73-3,1-4.48C450.36,126.18,450.43,125.86,450.47,125.55Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.09,59.52c-1.5.54-2.51,1.93-3.77,2.92s-3.27,1.46-4.28.23a2.94,2.94,0,0,1-.52-2.19,5.33,5.33,0,0,1,1.35-3c.76-.84,1.8-1.42,2.49-2.34s.88-2.41,0-3.08c-.49-.37-1.2-.4-1.61-.86-.73-.82.19-2.23,1.27-2.42a7.66,7.66,0,0,1,3.2.61c3.85,1,7.22-1,10.58-2.58,2.61-1.23,7.85-2.26,10.14,0,.92.89,1,2.73-.16,3.31-.51.26-1.14.21-1.63.51s-.8,1.11-1.21,1.67c-1.05,1.46-3.29,1.62-4.3,3.11-.61.9-.66,2.16-1.46,2.88a3.73,3.73,0,0,1-2.41.68l-5.32.22A7.61,7.61,0,0,0,377.09,59.52Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.32,81.19c1.48-.85,3.67-.55,4.37,1,.5,1.11.07,2.41-.34,3.56-.57,1.56-1.13,3.11-1.7,4.66a2.65,2.65,0,0,0-.22,1.46c.27,1.11,1.94,1.24,2.75.45a4.59,4.59,0,0,0,1-3.18,6.43,6.43,0,0,1,.69-3.32c1.57-2.37,5.27-1.23,7.79-2.48,1.57-.77,2.52-2.39,3.63-3.76s2.76-2.63,4.44-2.21c.57.13,1.09.46,1.67.55a2.39,2.39,0,0,0,2.22-3.48,4,4,0,0,1-.59-.92,1.46,1.46,0,0,1,.86-1.6,4,4,0,0,1,1.9-.23c1.49,0,3,.1,4.45.16,1.63.06,3.83-.37,3.92-2,.09-1.43-1.65-2.43-1.65-3.87a4.7,4.7,0,0,0,0-1.06c-.26-1-1.64-.87-2.57-.56a2.1,2.1,0,0,0-3-1.65c-1,.54-1.34,1.78-1.85,2.79-1.22,2.46-3.64,4-5.94,5.48a3.92,3.92,0,0,1-2.52.85c-.89-.13-1.62-1.28-1.06-2,.38-.48,1.21-.65,1.25-1.27.05-.78-1.26-1-1.37-1.76.93-2,3.52-2.45,5.6-3.23a12,12,0,0,0,6.09-5.15,1.61,1.61,0,0,0,.31-1.24c-.17-.6-.87-.82-1.47-.94-1.42-.31-3.24-.46-4,.79a18,18,0,0,0-.7,2.26c-.94,2.15-4,1.8-6.14,2.78a17.53,17.53,0,0,1-2.4,1.23,11.41,11.41,0,0,1-2.92-.09h0c-.75.71-1.78,1.71-2.49,2.46s-1.34,1.45-2,2.23a69.65,69.65,0,0,0-8.74,11.84q-1.26,2.28-2.36,4.67c-.72,1.59-1.4,3.22-2,4.88a20,20,0,0,0,2.06-4.07A8.08,8.08,0,0,1,324.32,81.19Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.29,159.14h0c.57.69,1.16,1.34,1.76,2s.95,1,1.44,1.53,1,1,1.49,1.47c.35.34.71.67,1.07,1l-.09-.38c-.82-3.59,0-8.38,3.54-9.38a7.35,7.35,0,0,0,2-.61c1.69-1.09,1.09-4.13,2.77-5.22.95-.6,2.18-.3,3.26-.56,1.94-.48,3-2.68,3.23-4.7s0-4.11.61-6.05c.94-2.93,3.84-5.52,3.06-8.49-.88-3.31-5.28-3.68-8.05-5.63-3.85-2.73-4.1-8.34-6.12-12.67-1.81-3.87-6.86-8.73-11.46-8.58a5.54,5.54,0,0,0-5.61,4.15l-.39-.15c-1.16-.36-2.53-.7-3-1.82-.52-1.31.56-2.89,0-4.18-.29-.67-.94-1.07-1.43-1.61s-.82-1.4-.35-2,1.16-.43,1.63-.85a1.14,1.14,0,0,0,.24-1.36c-.92-1.7-2.86,1-3.67,1.59a7.41,7.41,0,0,1-.64.41h0a2.54,2.54,0,0,0-.1.37c-.1.41-.18.82-.27,1.23s-.18.82-.26,1.23-.12.67-.18,1-.13.67-.19,1c0,.17-.06.32-.08.48a70.56,70.56,0,0,0,0,22.56,66,66,0,0,0,2.33,9.78c.41,1.38.89,2.75,1.41,4.1.64,1.67,1.33,3.31,2.11,4.92s1.49,3,2.34,4.52a68.17,68.17,0,0,0,3.77,5.93c1.2,1.7,2.47,3.33,3.83,4.92",
    style: {
      opacity: 0.30000000000000004
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Leaves--inject-86"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M313.37,68.7s1.38-13.2-10.05-19.5a29.09,29.09,0,0,0-21.81-2.81s1.19,19.11,13,24.71c0,0,5.43,3.53,14.52,1l4,5.43L315.69,75C308.53,65.19,289.36,52,289.36,52a90.16,90.16,0,0,1,14.8,9.14A104.6,104.6,0,0,1,313.37,68.7Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.26,49.65s3.08-5.45-.69-10.33A13.74,13.74,0,0,0,321.66,34s-3.08,8.5,1,13.14c0,0,1.69,2.56,6.11,3.16l.91,4.14,1.76-.84C330.17,48,324,37.89,324,37.89a42.9,42.9,0,0,1,4.69,6.75A50.52,50.52,0,0,1,331.26,49.65Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.57,191.6s9.08-8.36,20.14-3.33A27.07,27.07,0,0,1,429.91,203s-14.92,9.73-25.66,4c0,0-5.65-2.09-8.79-10.29l-8.35.1.82-3.75c11.32-.13,33.45,7.17,33.45,7.17a84.44,84.44,0,0,0-15-6A96.48,96.48,0,0,0,395.57,191.6Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Document--inject-86"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "376.07 115.2 377.45 379.71 181.25 379.35 167.47 367.04 179.86 112.31 363.9 97.12 376.07 115.2",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "363.9 97.12 363.7 366.86 167.47 367.04 169.92 97.43 363.9 97.12",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.9,97.12l-194,.52.21-.21c-.67,75.38-1.5,168.72-2.4,269.61l-.26-.26h1.16l195.07-.15-.24.23c.26-159.52.43-267.65.44-269.74,0,2.09,0,110.22,0,269.74v.24h-.24l-195.07.2h-1.42V367c.94-100.89,1.8-194.23,2.5-269.62v-.2h.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.77,162.48l65.94-.45a3.9,3.9,0,0,0,3.87-3.92h0a3.89,3.89,0,0,0-3.92-3.86l-65.94.46a3.87,3.87,0,0,0-3.86,3.91h0A3.87,3.87,0,0,0,198.77,162.48Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.65,177.53l66-.46a3.88,3.88,0,0,0,3.86-3.91h0a3.89,3.89,0,0,0-3.91-3.87l-66,.46a3.89,3.89,0,0,0-3.86,3.92h0A3.89,3.89,0,0,0,198.65,177.53Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.54,192.57l65.94-.45a3.9,3.9,0,0,0,3.87-3.92h0a3.89,3.89,0,0,0-3.92-3.86l-65.94.46a3.89,3.89,0,0,0-3.87,3.91h0A3.89,3.89,0,0,0,198.54,192.57Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.42,207.62l66-.46a3.89,3.89,0,0,0,3.86-3.92h0a3.9,3.9,0,0,0-3.92-3.86l-65.94.46a3.88,3.88,0,0,0-3.86,3.91h0A3.89,3.89,0,0,0,198.42,207.62Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.31,222.66l65.94-.46a3.87,3.87,0,0,0,3.86-3.91h0a3.87,3.87,0,0,0-3.91-3.86l-65.95.45a3.9,3.9,0,0,0-3.86,3.92h0A3.89,3.89,0,0,0,198.31,222.66Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.19,237.7l65.95-.45a3.9,3.9,0,0,0,3.86-3.92h0a3.9,3.9,0,0,0-3.92-3.86l-65.94.46a3.88,3.88,0,0,0-3.86,3.91h0A3.88,3.88,0,0,0,198.19,237.7Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.08,252.75l65.94-.46a3.87,3.87,0,0,0,3.86-3.91h0a3.87,3.87,0,0,0-3.91-3.86L198,245a3.9,3.9,0,0,0-3.86,3.92h0A3.89,3.89,0,0,0,198.08,252.75Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280,236.59,346,237a3.89,3.89,0,0,0,3.91-3.87h0a3.89,3.89,0,0,0-3.86-3.91l-65.95-.41a3.89,3.89,0,0,0-3.91,3.87h0A3.89,3.89,0,0,0,280,236.59Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.7,251.63l65.95.41a3.9,3.9,0,0,0,3.91-3.87h0a3.9,3.9,0,0,0-3.87-3.91l-65.94-.4a3.87,3.87,0,0,0-3.91,3.86h0A3.87,3.87,0,0,0,279.7,251.63Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.27,267.5l66,.4a3.89,3.89,0,0,0,3.91-3.86h0a3.89,3.89,0,0,0-3.87-3.91l-65.94-.41a3.89,3.89,0,0,0-3.91,3.86h0A3.89,3.89,0,0,0,279.27,267.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.84,283.36l66,.41a3.9,3.9,0,0,0,3.91-3.87h0a3.89,3.89,0,0,0-3.87-3.91l-65.94-.41a3.89,3.89,0,0,0-3.91,3.87h0A3.88,3.88,0,0,0,278.84,283.36Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.41,299.22l65.95.41a3.9,3.9,0,0,0,3.91-3.86h0a3.9,3.9,0,0,0-3.87-3.92l-65.94-.4a3.87,3.87,0,0,0-3.91,3.86h0A3.87,3.87,0,0,0,278.41,299.22Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,315.09l65.95.4a3.89,3.89,0,0,0,3.91-3.86h0a3.89,3.89,0,0,0-3.87-3.91L278,307.31a3.89,3.89,0,0,0-3.91,3.86h0A3.89,3.89,0,0,0,278,315.09Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.55,331l65.95.41a3.9,3.9,0,0,0,3.91-3.87h0a3.89,3.89,0,0,0-3.87-3.91l-65.94-.41a3.89,3.89,0,0,0-3.91,3.87h0A3.87,3.87,0,0,0,277.55,331Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.4,345.26l149.93.93a3.89,3.89,0,0,0,3.91-3.87h0a3.89,3.89,0,0,0-3.86-3.91l-149.93-.92a2.6,2.6,0,0,0-2.62,2.58v2.57A2.59,2.59,0,0,0,193.4,345.26Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.24,142.88l43.64-.3a3.89,3.89,0,0,0,3.86-3.92h0a3.89,3.89,0,0,0-3.91-3.86l-43.64.31a3.87,3.87,0,0,0-3.86,3.91h0A3.88,3.88,0,0,0,199.24,142.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "247.83 93.62 250.59 90.96 283.78 90.79 285.42 93.72 247.83 93.62",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.95,
    y: 82.53,
    width: 15.32,
    height: 37.58,
    transform: "translate(368.4 -165.11) rotate(90.1)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.04,
    y: 89.12,
    width: 3.06,
    height: 40.19,
    rx: 1.25,
    transform: "translate(376.21 -157.17) rotate(90.09)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.89,105.27h0l-16.53,0a1.45,1.45,0,0,1-1.19-.6,1.36,1.36,0,0,1-.18-1.29l4.72-12.72a8.29,8.29,0,0,1-3.55-6.55,8.5,8.5,0,0,1,8.31-8.56,8.72,8.72,0,0,1,6.31,2.34,8.19,8.19,0,0,1-1,12.83l4.49,12.73a1.4,1.4,0,0,1-.19,1.28A1.49,1.49,0,0,1,274.89,105.27Zm-8.21-28.76h-.2a7.57,7.57,0,0,0-7.3,7.53,7.3,7.3,0,0,0,3.43,6l.34.22-5,13.46a.38.38,0,0,0,.05.37.41.41,0,0,0,.34.17l16.53,0a.41.41,0,0,0,.34-.16.38.38,0,0,0,.05-.37l-4.75-13.47.35-.21a7.27,7.27,0,0,0,3.5-6.17,7.18,7.18,0,0,0-2.32-5.3A7.65,7.65,0,0,0,266.68,76.51Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.11,107.73a2.12,2.12,0,0,0-.37,0l-1.08,0-4,0-13.11-.08-13.11,0-4,0-1.08,0a1.88,1.88,0,0,0-.38,0,1.88,1.88,0,0,0,.38,0l1.08,0,4,.06c3.35,0,8,.09,13.11.11s9.76,0,13.11,0c1.68,0,3,0,4-.05l1.08,0A1.37,1.37,0,0,0,285.11,107.73Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.49,93.4a2.79,2.79,0,0,0-.38,0H284l-4,0L267,93.25l-13.12,0-4,0-1.08,0a1.88,1.88,0,0,0-.38,0l.38,0,1.08,0,4,.07c3.36,0,8,.08,13.12.1s9.75,0,13.11,0c1.68,0,3,0,4-.06.47,0,.84,0,1.09,0A1.38,1.38,0,0,0,285.49,93.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 363.7,
    y1: 366.86,
    x2: 377.45,
    y2: 379.72,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.45,379.72a89.34,89.34,0,0,1-7.05-6.24,83.44,83.44,0,0,1-6.7-6.62,85.33,85.33,0,0,1,7.05,6.24A83.44,83.44,0,0,1,377.45,379.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.81,374.15l.92,0,2.68,0,10.33-.05L243,374l128.27-.08-.26.26V353.83c0-55.44.05-105.63.07-142,0-18.16.07-32.85.08-43,0-5.07,0-9,.05-11.7,0-1.33,0-2.35,0-3s0-1,0-1,0,.35,0,1,0,1.71,0,3c0,2.69,0,6.63.05,11.7,0,10.17,0,24.86.08,43,0,36.34.05,86.53.08,142v20.58h-.26L243,374.32l-38.24-.07-10.33-.05-2.68,0C191.12,374.17,190.81,374.15,190.81,374.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.38,296a30.55,30.55,0,1,1-31-30.2A30.66,30.66,0,0,1,257.38,296Zm-45.15.72A14.61,14.61,0,1,0,226.6,281.8,14.65,14.65,0,0,0,212.23,296.71Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.38,296a30.66,30.66,0,0,1-30.06,31.19l-.25-16a14.68,14.68,0,0,0-.47-29.35l-.26-16A30.65,30.65,0,0,1,257.38,296Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.07,329.63a34.91,34.91,0,0,1-35.75-34.77l18.65-.3c.15,9.46,7.36,15.42,16.78,15.27Z",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205,295.18a53.23,53.23,0,0,1-3.94,6.17,52.24,52.24,0,0,1-4.37,5.88,52.58,52.58,0,0,1,3.94-6.17A50.84,50.84,0,0,1,205,295.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.14,296.74c.12.08-2.49,4.07-5.82,8.91s-6.14,8.7-6.25,8.62,2.49-4.07,5.82-8.91S213,296.66,213.14,296.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.09,305a88.66,88.66,0,0,1-5.24,8.07,89.21,89.21,0,0,1-5.68,7.78,88.58,88.58,0,0,1,5.25-8.07A88,88,0,0,1,217.09,305Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224,309.62a89.2,89.2,0,0,1-5.25,8.07,88.69,88.69,0,0,1-5.67,7.77,90.3,90.3,0,0,1,5.24-8.07A89.91,89.91,0,0,1,224,309.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.84,315.44a61.14,61.14,0,0,1-4.28,6.68,60.23,60.23,0,0,1-4.72,6.38,122,122,0,0,1,9-13.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.93,214.61h0l-57.7-.68a1.05,1.05,0,0,1-.71-.31,1,1,0,0,1-.28-.71l.54-45.22a1,1,0,0,1,1-1,1,1,0,0,1,1,1l-.53,44.23,56.7.67a1,1,0,0,1,0,2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.14,
    y: 195.58,
    width: 7.75,
    height: 14.23,
    transform: "translate(2.44 -3.51) rotate(0.68)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.04,
    y: 195.58,
    width: 7.75,
    height: 14.23,
    transform: "translate(2.44 -3.83) rotate(0.68)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.7,
    y: 184.18,
    width: 7.75,
    height: 25.87,
    transform: "translate(2.38 -3.67) rotate(0.68)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.51,
    y: 184.18,
    width: 7.75,
    height: 25.87,
    transform: "translate(2.38 -3.99) rotate(0.68)",
    style: {
      fill: "#92E3A9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.32,189.32a1,1,0,0,1-.74-.32,1,1,0,0,1,.06-1.41l17.79-16.29a1,1,0,0,1,1.29-.06L319.94,180l24-17.09a1,1,0,1,1,1.16,1.63l-24.58,17.52a1,1,0,0,1-1.19,0l-11.14-8.69L291,189.06A1,1,0,0,1,290.32,189.32Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.53,172.84s-5.19-1.68-4.12-9.19,5.4-10.42,5.4-10.42,4.89,5.11,4.91,11.59-4.29,8-4.29,8l-.88-12.58Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.45,172.89s-2.16-5.33,4.64-9.55,12.06-2.69,12.06-2.69-.81,7.41-6,11.81-9.71,1.71-9.71,1.71l10-7.94Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.49,141.72H332.92a4.74,4.74,0,0,1-4.74-4.74h0a4.74,4.74,0,0,1,4.74-4.73h13.57a4.73,4.73,0,0,1,4.73,4.73h0A4.74,4.74,0,0,1,346.49,141.72Z",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-86"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 379.58,
    y: 439.95,
    width: 12.61,
    height: 30.02,
    rx: 1.07,
    transform: "translate(771.77 909.92) rotate(180)",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.68,439.2s-.62-.41.75-2.2a1.74,1.74,0,0,0,.43-1.45,1.38,1.38,0,0,0-1.93-.9,15.39,15.39,0,0,1-9,.82,1.43,1.43,0,0,1-.29-2.74c2.83-1.15,6.15-2.79,6.84-4.4a2.34,2.34,0,0,0,.24-1.41,1.29,1.29,0,0,1,.65-1.54,2.68,2.68,0,0,0,1.34-1c.58-1-.75-2.15-1.7-2.79a1.36,1.36,0,0,1-.61-1.26,3.6,3.6,0,0,0-.23-1.59c-.33-.9-5-2-8.69-2.82a1.42,1.42,0,0,1-.71-2.39,6.41,6.41,0,0,0,.8-1.11,1.42,1.42,0,0,1,1.18-.71c1.77-.06,5.83-.41,7-2.33,1.49-2.47-1-3.16-5.21-5.22-2.81-1.38-7.89-5.27-11-7.7a1.43,1.43,0,0,1,.61-2.53,10.83,10.83,0,0,0,4.27-1.47,2.46,2.46,0,0,0,.65-.74,1.44,1.44,0,0,1,1.23-.82c4.76-.08,2.84-3.11,2.84-3.11a32,32,0,0,1-12.65-7.48,1.42,1.42,0,0,1,.52-2.37,13.47,13.47,0,0,0,4.43-2.39c.67-.62.77-1.11.58-1.48a1.31,1.31,0,0,1,.6-1.88c1.71-.63,3-1.72.43-3.38-1.77-1.14-4.07-2.48-6.16-3.65a1.43,1.43,0,0,1,.5-2.66l.95-.16c5.21-2.34,0-5.78,0-5.78A71,71,0,0,1,402,348.71a1.43,1.43,0,0,1,1-2.5,3.53,3.53,0,0,0,1-.13c2.24-.69-2.48-3.44-2.48-3.44s2.36.69,3.35,0-2.6-3.85-2.6-3.85c-4.71-3.06-10.38-10.48-13.55-14.89a1.41,1.41,0,0,0-2.31,0c-3.18,4.41-8.85,11.83-13.55,14.89,0,0-3.6,3.16-2.61,3.85s3.35,0,3.35,0-4.71,2.75-2.48,3.44a3.58,3.58,0,0,0,1,.13,1.43,1.43,0,0,1,1,2.5,71.53,71.53,0,0,1-10.34,7.82s-5.22,3.44,0,5.78l.95.16a1.43,1.43,0,0,1,.5,2.66c-2.09,1.17-4.39,2.51-6.17,3.65-2.6,1.66-1.27,2.75.44,3.38a1.31,1.31,0,0,1,.59,1.88c-.19.37-.09.86.58,1.48a13.47,13.47,0,0,0,4.43,2.39,1.43,1.43,0,0,1,.53,2.37A32.19,32.19,0,0,1,352,387.76s-1.93,3,2.84,3.11a1.44,1.44,0,0,1,1.22.82,2.69,2.69,0,0,0,.66.74A10.78,10.78,0,0,0,361,393.9a1.43,1.43,0,0,1,.62,2.53c-3.07,2.43-8.15,6.32-11,7.7-4.22,2.06-6.7,2.75-5.21,5.22,1.16,1.92,5.21,2.27,7,2.33a1.39,1.39,0,0,1,1.18.71,6.52,6.52,0,0,0,.81,1.11,1.43,1.43,0,0,1-.71,2.39c-3.72.78-8.36,1.92-8.69,2.82a3.33,3.33,0,0,0-.23,1.59,1.34,1.34,0,0,1-.62,1.26c-.95.64-2.28,1.78-1.7,2.79a2.71,2.71,0,0,0,1.35,1,1.29,1.29,0,0,1,.64,1.54,2.36,2.36,0,0,0,.25,1.41c.69,1.61,4,3.25,6.83,4.4a1.43,1.43,0,0,1-.28,2.74,15.38,15.38,0,0,1-9-.82,1.38,1.38,0,0,0-1.93.9,1.71,1.71,0,0,0,.43,1.45c1.36,1.79.74,2.2.74,2.2s-3.1-2.34-1.74,1.24c.77,2,3.4,3.6,5.54,4.59a1.43,1.43,0,0,1,.36,2.35,1.32,1.32,0,0,0-.19,1.72c1.24,2.21,6.46,4.82,12.16,5.37a36,36,0,0,0,9.06-.59,1.37,1.37,0,0,1,1.5,1.75c-.13.57.15,1.14,1.23,1.59,2.07.87,4.3.11,5.82-.7a1.42,1.42,0,0,1,2,.65c.25.59.84,1,2.14.44a18.14,18.14,0,0,0,3.82-2.21,1.43,1.43,0,0,1,2.19.71c.46,1.29,1.21,2.58,2.24,1.89,1,.69,1.78-.6,2.24-1.89a1.44,1.44,0,0,1,2.2-.71,18.31,18.31,0,0,0,3.81,2.21c1.3.52,1.89.15,2.15-.44a1.41,1.41,0,0,1,2-.65c1.53.81,3.76,1.57,5.82.7,1.08-.45,1.37-1,1.24-1.59a1.36,1.36,0,0,1,1.5-1.75,35.93,35.93,0,0,0,9.05.59c5.71-.55,10.92-3.16,12.16-5.37a1.3,1.3,0,0,0-.19-1.72,1.44,1.44,0,0,1,.36-2.35c2.14-1,4.77-2.57,5.54-4.59C436.79,436.86,433.68,439.2,433.68,439.2Z",
    style: {
      fill: "#455a64"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M405.72,357l-.2-.09A.72.72,0,0,1,405.72,357Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M396.37,342.84,394.3,342a1.46,1.46,0,0,0-1.46.25,3.54,3.54,0,0,1-4.16.23,11.92,11.92,0,0,1-4-3.65,1.42,1.42,0,0,0-1.84-.42c-1.31.71-3.34,1.59-3.64.37a2.2,2.2,0,0,1,1.36-2.54,1.12,1.12,0,0,0-.11,1c.19.33.62.32,1,.23a5.41,5.41,0,0,0,1.7-.76,1.48,1.48,0,0,1,2.06.27,11.66,11.66,0,0,0,3.66,3.12,3.31,3.31,0,0,0,2.58.6,1.47,1.47,0,0,0,.64-.45,1.36,1.36,0,0,1,1.85-.2,7.53,7.53,0,0,0,3.81,1.44c.45,0,1-.08,1.12-.58a1.1,1.1,0,0,0-.27-.8,9.39,9.39,0,0,0-2.32-2.38,13.36,13.36,0,0,0,6.73,2.55l2.1.28a.48.48,0,0,1-.14.58c-1,.69-3.35,0-3.35,0s4.72,2.76,2.48,3.44-6.7-1.65-6.7-1.65l.55.53Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M370.07,361.31l4.31-1.56a1.4,1.4,0,0,1,1.74.66,3.75,3.75,0,0,0,3.74,2.16,3,3,0,0,0,2.88-1.65,1.41,1.41,0,0,1,1.93-.64,12.18,12.18,0,0,0,7.3,1s1-.13.76-1.75a3.31,3.31,0,0,0,4.27.59c2.7-1.43.36-3.83.36-3.83l-.36-.19a1.89,1.89,0,0,1,.28,1.55c-.3.71-1.22.66-1.9.44a14.8,14.8,0,0,1-5.21-2.92,5.63,5.63,0,0,1,1.08,1.64,2.05,2.05,0,0,1-.19,1.93,2.09,2.09,0,0,1-1.64.66,9.75,9.75,0,0,1-8-3.64c0,.92.19,1.84.16,2.76a2.35,2.35,0,0,1-1.23,2.21c-.94.33-1.9-.55-2.32-1.55a8.62,8.62,0,0,1-.32-1,1.41,1.41,0,0,0-2.17-.82,12,12,0,0,1-3.36,1.71,3.38,3.38,0,0,1-1.57.2,1.56,1.56,0,0,1-1.22-1,1.21,1.21,0,0,1,.39-1.33c-2.3,1.05-7.61,2.91-8.66.31-.56,1.12-.44,2.48,2,3.59,0,0,4.43.86,6.39.14l-1.39.74,1.7-.37Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M409.91,378.25a10.74,10.74,0,0,1-3.15-1,1.38,1.38,0,0,0-1.57.21,2.57,2.57,0,0,1-2.22.63,5.1,5.1,0,0,1-2-.93,1.39,1.39,0,0,0-1.72.16,4.26,4.26,0,0,1-2.57,1.06,4.22,4.22,0,0,1-2.71-.88,1.49,1.49,0,0,0-1.74-.07c-3.41,2.32-7.34,3.92-11.29,3.39a3.08,3.08,0,0,1-2.16-1,1.52,1.52,0,0,1-.29-.69,1.42,1.42,0,0,0-1.65-1.12,12.93,12.93,0,0,1-5.74-.05,5.37,5.37,0,0,1-4.15-6.3,6.69,6.69,0,0,0,.68,1.9,2.59,2.59,0,0,0,1.48,1,16.86,16.86,0,0,0,11.15-.17,1.37,1.37,0,0,1,1.79.88,2.6,2.6,0,0,0,1.15,1.56,5.25,5.25,0,0,0,3.61.19,15.18,15.18,0,0,0,3.88-1.15,7.17,7.17,0,0,0,1.87-1.33,1.41,1.41,0,0,1,2.13.07,4.62,4.62,0,0,0,.75.78,2.32,2.32,0,0,0,2.66.34,1.7,1.7,0,0,0,.62-.77,1.46,1.46,0,0,1,1.93-.7,17.13,17.13,0,0,0,3.45,1.11,1.39,1.39,0,0,0,1.42-.25,1.28,1.28,0,0,0-.09-1.53,1.67,1.67,0,0,0-.43-.41,15.62,15.62,0,0,0,8.88,1.46l0,.55a20.06,20.06,0,0,1-5.09,1.95S409.22,377.54,409.91,378.25Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M361.8,397.14a24.2,24.2,0,0,0,7.26-1.86,1.46,1.46,0,0,1,1.31.15,12.8,12.8,0,0,0,13.5.07,1.43,1.43,0,0,1,1.62.09,9.81,9.81,0,0,0,11,.52,1.51,1.51,0,0,1,1.35-.15,9.08,9.08,0,0,0,5.48.86,5,5,0,0,0,4-4.77,6.55,6.55,0,0,1-5,2.41,6.42,6.42,0,0,1-4-1.45,1.49,1.49,0,0,0-1.95.06,7,7,0,0,1-5.05,1.82,7.15,7.15,0,0,1-4.83-2.52,1.45,1.45,0,0,0-1.9-.31,12.73,12.73,0,0,1-9,2.14,5,5,0,0,1-2.82-1.19,3.09,3.09,0,0,1-.68-1,1.42,1.42,0,0,0-1.94-.82,13.22,13.22,0,0,1-14-1.13l0,.09a2.45,2.45,0,0,0,.71.85,10.77,10.77,0,0,0,4.27,1.47,1.42,1.42,0,0,1,.61,2.52c-.77.61-1.66,1.31-2.61,2A13.12,13.12,0,0,0,361.8,397.14Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M425.61,409.93a19.77,19.77,0,0,1-2.87.29,1.42,1.42,0,0,0-1.19.71,4.78,4.78,0,0,1-4.74,2.61s1.85.31,4.17.79a9.23,9.23,0,0,1-7.81-.57,1.37,1.37,0,0,0-1.57.22,12.45,12.45,0,0,1-15.28.51,1.4,1.4,0,0,0-1.65,0,12.59,12.59,0,0,1-14.81.14,1.37,1.37,0,0,0-1.63,0,11.16,11.16,0,0,1-8.32,2.5,9.05,9.05,0,0,1-4.25-1.85,1.44,1.44,0,0,1,1.25-2.52A13.54,13.54,0,0,0,378,410.67a1.41,1.41,0,0,1,2,.31,3.18,3.18,0,0,0,1.22.91,6.66,6.66,0,0,0,2.91.31c3.6-.19,7.39-.72,10.38-2.86a1.42,1.42,0,0,1,1.82.18,9.16,9.16,0,0,0,7.36,2.74,9.59,9.59,0,0,0,6.8-4.29,1.45,1.45,0,0,1,1.8-.5,18.83,18.83,0,0,0,16.84-.94l-2.7,3A1.39,1.39,0,0,1,425.61,409.93Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M402.58,428.68a1.43,1.43,0,0,0-1.79.76,4,4,0,0,1-1.44,1.78,6.16,6.16,0,0,1-3.34.91,14.24,14.24,0,0,1-8.87-2.8,1.39,1.39,0,0,0-1.8.15,10.46,10.46,0,0,1-15.4-.29,1.46,1.46,0,0,0-1.43-.45,30,30,0,0,1-22.71-3.58l-1.07.59a3,3,0,0,0,.27,1.13c1.24,2.89,11.05,5.91,11.05,5.91a21.87,21.87,0,0,1-2.54.81c1.69.51,3.16.93,4.08,1.23a10,10,0,0,0,9.14-1.41,1.42,1.42,0,0,1,1.87.08,11.78,11.78,0,0,0,16.76-.08,1.41,1.41,0,0,1,2,0A11.71,11.71,0,0,0,394.8,437a7.66,7.66,0,0,0,7.11-4.34,1.42,1.42,0,0,1,1.57-.83,5.58,5.58,0,0,0,.59.1c1.82.24,2.14-2.52.33-2.83A12.43,12.43,0,0,1,402.58,428.68Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M433.68,439.2s-.62-.41.75-2.2a1.74,1.74,0,0,0,.43-1.45,1.38,1.38,0,0,0-1.93-.9,15.39,15.39,0,0,1-9,.82,1.43,1.43,0,0,1-.29-2.74c2.83-1.15,6.15-2.79,6.84-4.4a2.34,2.34,0,0,0,.24-1.41,1.29,1.29,0,0,1,.65-1.54,2.68,2.68,0,0,0,1.34-1c.58-1-.75-2.15-1.7-2.79a1.36,1.36,0,0,1-.61-1.26,3.6,3.6,0,0,0-.23-1.59c-.33-.9-5-2-8.69-2.82a1.42,1.42,0,0,1-.71-2.39,6.41,6.41,0,0,0,.8-1.11,1.42,1.42,0,0,1,1.18-.71c1.77-.06,5.83-.41,7-2.33,1.49-2.47-1-3.16-5.21-5.22-2.81-1.38-7.89-5.27-11-7.7a1.43,1.43,0,0,1,.61-2.53,10.83,10.83,0,0,0,4.27-1.47,2.46,2.46,0,0,0,.65-.74,1.44,1.44,0,0,1,1.23-.82c4.76-.08,2.84-3.11,2.84-3.11a32,32,0,0,1-12.65-7.48,1.42,1.42,0,0,1,.52-2.37,13.47,13.47,0,0,0,4.43-2.39c.67-.62.77-1.11.58-1.48a1.31,1.31,0,0,1,.6-1.88c1.71-.63,3-1.72.43-3.38-1.77-1.14-4.07-2.48-6.16-3.65a1.43,1.43,0,0,1,.5-2.66l.95-.16c5.21-2.34,0-5.78,0-5.78A71,71,0,0,1,402,348.71a1.43,1.43,0,0,1,1-2.5,3.53,3.53,0,0,0,1-.13c2.24-.69-2.48-3.44-2.48-3.44s2.36.69,3.35,0-2.6-3.85-2.6-3.85c-4.71-3.06-10.38-10.48-13.55-14.89a1.41,1.41,0,0,0-2.31,0c-3.18,4.41-8.85,11.83-13.55,14.89,0,0-3.6,3.16-2.61,3.85s3.35,0,3.35,0-4.71,2.75-2.48,3.44a3.58,3.58,0,0,0,1,.13,1.43,1.43,0,0,1,1,2.5,71.53,71.53,0,0,1-10.34,7.82s-5.22,3.44,0,5.78l.95.16a1.43,1.43,0,0,1,.5,2.66c-2.09,1.17-4.39,2.51-6.17,3.65-2.6,1.66-1.27,2.75.44,3.38a1.31,1.31,0,0,1,.59,1.88c-.19.37-.09.86.58,1.48a13.47,13.47,0,0,0,4.43,2.39,1.43,1.43,0,0,1,.53,2.37A32.19,32.19,0,0,1,352,387.76s-1.93,3,2.84,3.11a1.44,1.44,0,0,1,1.22.82,2.69,2.69,0,0,0,.66.74A10.78,10.78,0,0,0,361,393.9a1.43,1.43,0,0,1,.62,2.53c-3.07,2.43-8.15,6.32-11,7.7-4.22,2.06-6.7,2.75-5.21,5.22,1.16,1.92,5.21,2.27,7,2.33a1.39,1.39,0,0,1,1.18.71,6.52,6.52,0,0,0,.81,1.11,1.43,1.43,0,0,1-.71,2.39c-3.72.78-8.36,1.92-8.69,2.82a3.33,3.33,0,0,0-.23,1.59,1.34,1.34,0,0,1-.62,1.26c-.95.64-2.28,1.78-1.7,2.79a2.71,2.71,0,0,0,1.35,1,1.29,1.29,0,0,1,.64,1.54,2.36,2.36,0,0,0,.25,1.41c.69,1.61,4,3.25,6.83,4.4a1.43,1.43,0,0,1-.28,2.74,15.38,15.38,0,0,1-9-.82,1.38,1.38,0,0,0-1.93.9,1.71,1.71,0,0,0,.43,1.45c1.36,1.79.74,2.2.74,2.2s-3.1-2.34-1.74,1.24c.77,2,3.4,3.6,5.54,4.59a1.43,1.43,0,0,1,.36,2.35,1.32,1.32,0,0,0-.19,1.72c1.24,2.21,6.46,4.82,12.16,5.37a36,36,0,0,0,9.06-.59,1.37,1.37,0,0,1,1.5,1.75c-.13.57.15,1.14,1.23,1.59,2.07.87,4.3.11,5.82-.7a1.42,1.42,0,0,1,2,.65c.25.59.84,1,2.14.44a18.14,18.14,0,0,0,3.82-2.21,1.43,1.43,0,0,1,2.19.71c.46,1.29,1.21,2.58,2.24,1.89,1,.69,1.78-.6,2.24-1.89a1.44,1.44,0,0,1,2.2-.71,18.31,18.31,0,0,0,3.81,2.21c1.3.52,1.89.15,2.15-.44a1.41,1.41,0,0,1,2-.65c1.53.81,3.76,1.57,5.82.7,1.08-.45,1.37-1,1.24-1.59a1.36,1.36,0,0,1,1.5-1.75,35.93,35.93,0,0,0,9.05.59c5.71-.55,10.92-3.16,12.16-5.37a1.3,1.3,0,0,0-.19-1.72,1.44,1.44,0,0,1,.36-2.35c2.14-1,4.77-2.57,5.54-4.59C436.79,436.86,433.68,439.2,433.68,439.2Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 337.51,
    y: 448.99,
    width: 8.81,
    height: 20.98,
    rx: 1.07,
    transform: "translate(683.83 918.97) rotate(180)",
    style: {
      fill: "#6f4439"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.31,448.29s-.43-.29.52-1.54a1.18,1.18,0,0,0,.3-1,1,1,0,0,0-1.35-.63,10.84,10.84,0,0,1-6.3.58,1,1,0,0,1-.2-1.92c2-.8,4.3-1.95,4.78-3.07a1.72,1.72,0,0,0,.17-1,.9.9,0,0,1,.45-1.08,1.89,1.89,0,0,0,.94-.72c.41-.71-.52-1.5-1.18-2a.93.93,0,0,1-.44-.88,2.2,2.2,0,0,0-.16-1.11c-.23-.63-3.47-1.42-6.07-2a1,1,0,0,1-.5-1.67,4.56,4.56,0,0,0,.57-.77,1,1,0,0,1,.82-.5c1.24,0,4.07-.29,4.88-1.63,1-1.72-.69-2.21-3.64-3.65a56.58,56.58,0,0,1-7.66-5.38,1,1,0,0,1,.43-1.76,7.61,7.61,0,0,0,3-1,2,2,0,0,0,.46-.51,1,1,0,0,1,.85-.58c3.33,0,2-2.17,2-2.17a22.38,22.38,0,0,1-8.83-5.23,1,1,0,0,1,.36-1.65,9.3,9.3,0,0,0,3.1-1.68c.47-.43.54-.77.4-1a.91.91,0,0,1,.42-1.31c1.2-.44,2.12-1.2.3-2.37-1.24-.79-2.84-1.72-4.3-2.54a1,1,0,0,1,.35-1.86l.66-.11c3.64-1.64,0-4,0-4a49,49,0,0,1-7.22-5.47,1,1,0,0,1,.7-1.75,2.27,2.27,0,0,0,.71-.08c1.56-.48-1.73-2.41-1.73-2.41s1.64.48,2.34,0-1.82-2.69-1.82-2.69c-3.29-2.13-7.25-7.32-9.47-10.4a1,1,0,0,0-1.62,0c-2.21,3.08-6.17,8.27-9.46,10.4,0,0-2.52,2.21-1.82,2.69s2.34,0,2.34,0-3.3,1.93-1.73,2.41a2.24,2.24,0,0,0,.7.08,1,1,0,0,1,.71,1.75,50.11,50.11,0,0,1-7.22,5.47s-3.65,2.4,0,4l.66.11a1,1,0,0,1,.35,1.86c-1.46.82-3.07,1.75-4.31,2.54-1.82,1.17-.89,1.93.31,2.37a.92.92,0,0,1,.41,1.31c-.13.26-.06.6.41,1a9.26,9.26,0,0,0,3.09,1.68,1,1,0,0,1,.37,1.65,22.51,22.51,0,0,1-8.84,5.23s-1.34,2.12,2,2.17a1,1,0,0,1,.86.58,1.79,1.79,0,0,0,.46.51,7.49,7.49,0,0,0,3,1,1,1,0,0,1,.43,1.76,57.85,57.85,0,0,1-7.66,5.38c-2.95,1.44-4.68,1.93-3.64,3.65.8,1.34,3.64,1.59,4.87,1.63a1,1,0,0,1,.83.5,4.45,4.45,0,0,0,.56.77,1,1,0,0,1-.5,1.67c-2.59.55-5.84,1.34-6.07,2a2.45,2.45,0,0,0-.16,1.11.94.94,0,0,1-.43.88c-.66.45-1.59,1.24-1.18,2a1.86,1.86,0,0,0,.93.72.92.92,0,0,1,.46,1.08,1.57,1.57,0,0,0,.17,1c.48,1.12,2.8,2.27,4.77,3.07a1,1,0,0,1-.2,1.92,10.85,10.85,0,0,1-6.3-.58,1,1,0,0,0-1.35.63,1.21,1.21,0,0,0,.3,1c.95,1.25.52,1.54.52,1.54s-2.17-1.63-1.21.87c.54,1.41,2.37,2.51,3.87,3.2a1,1,0,0,1,.25,1.64.92.92,0,0,0-.13,1.21c.86,1.54,4.51,3.36,8.49,3.75a25.34,25.34,0,0,0,6.33-.41,1,1,0,0,1,1.05,1.22c-.09.4.11.79.86,1.11a4.86,4.86,0,0,0,4.07-.49,1,1,0,0,1,1.37.46c.18.41.59.67,1.5.3a12.69,12.69,0,0,0,2.66-1.54,1,1,0,0,1,1.54.49c.32.9.84,1.81,1.56,1.33.73.48,1.25-.43,1.57-1.33a1,1,0,0,1,1.53-.49,12.78,12.78,0,0,0,2.67,1.54c.91.37,1.32.11,1.49-.3a1,1,0,0,1,1.38-.46,4.84,4.84,0,0,0,4.06.49c.76-.32,1-.71.87-1.11a1,1,0,0,1,1-1.22A25.37,25.37,0,0,0,364,459c4-.39,7.63-2.21,8.5-3.75a.93.93,0,0,0-.13-1.21,1,1,0,0,1,.25-1.64c1.49-.69,3.33-1.79,3.87-3.2C377.48,446.66,375.31,448.29,375.31,448.29Z",
    style: {
      fill: "#455a64"
    }
  }), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M355.77,390.82l-.13-.06A.31.31,0,0,1,355.77,390.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M349.24,381l-1.45-.57a1,1,0,0,0-1,.17,2.48,2.48,0,0,1-2.91.16,8.21,8.21,0,0,1-2.82-2.55,1,1,0,0,0-1.29-.29c-.92.5-2.33,1.11-2.54.26a1.54,1.54,0,0,1,.95-1.78.82.82,0,0,0-.08.71c.13.23.43.22.67.16a3.56,3.56,0,0,0,1.19-.54,1,1,0,0,1,1.44.2,8.08,8.08,0,0,0,2.56,2.17,2.29,2.29,0,0,0,1.8.43,1.07,1.07,0,0,0,.45-.32,1,1,0,0,1,1.29-.14,5.28,5.28,0,0,0,2.66,1c.32,0,.73-.06.79-.41a.85.85,0,0,0-.19-.56,6.73,6.73,0,0,0-1.62-1.66,9.3,9.3,0,0,0,4.69,1.78l1.47.2a.35.35,0,0,1-.09.41c-.7.48-2.34,0-2.34,0s3.29,1.92,1.73,2.4-4.68-1.15-4.68-1.15l.38.36Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M330.86,393.86l3-1.09a1,1,0,0,1,1.22.47,2.6,2.6,0,0,0,2.61,1.51,2.12,2.12,0,0,0,2-1.15,1,1,0,0,1,1.35-.45,8.45,8.45,0,0,0,5.1.69s.7-.09.53-1.22a2.33,2.33,0,0,0,3,.41c1.88-1,.24-2.68.24-2.68l-.25-.13a1.37,1.37,0,0,1,.2,1.08c-.21.5-.86.46-1.33.31a10.27,10.27,0,0,1-3.64-2,4,4,0,0,1,.75,1.15,1.43,1.43,0,0,1-.13,1.35,1.48,1.48,0,0,1-1.15.46,6.8,6.8,0,0,1-5.57-2.55c0,.65.13,1.29.11,1.93a1.66,1.66,0,0,1-.85,1.55c-.66.23-1.34-.39-1.63-1.09a5.39,5.39,0,0,1-.22-.68,1,1,0,0,0-1.52-.57,8.62,8.62,0,0,1-2.34,1.19,2.46,2.46,0,0,1-1.1.14,1.1,1.1,0,0,1-.86-.7.84.84,0,0,1,.28-.93c-1.61.73-5.32,2-6.05.22-.39.78-.31,1.73,1.42,2.51,0,0,3.1.6,4.47.1l-1,.51,1.19-.26Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M358.7,405.7a7.24,7.24,0,0,1-2.2-.7.94.94,0,0,0-1.09.15,1.85,1.85,0,0,1-1.56.44,3.55,3.55,0,0,1-1.37-.66,1,1,0,0,0-1.2.12,2.86,2.86,0,0,1-3.69.13,1,1,0,0,0-1.22-.05c-2.38,1.62-5.13,2.73-7.88,2.36a2.15,2.15,0,0,1-1.52-.72,1.09,1.09,0,0,1-.2-.48,1,1,0,0,0-1.15-.78,9.19,9.19,0,0,1-4,0,3.75,3.75,0,0,1-2.9-4.41,4.82,4.82,0,0,0,.47,1.33,1.81,1.81,0,0,0,1,.68A11.76,11.76,0,0,0,338,403a1,1,0,0,1,1.26.62,1.87,1.87,0,0,0,.8,1.09,3.63,3.63,0,0,0,2.52.13,10.76,10.76,0,0,0,2.72-.8,5.15,5.15,0,0,0,1.3-.93,1,1,0,0,1,1.49,0,3.07,3.07,0,0,0,.53.55,1.6,1.6,0,0,0,1.85.24,1.13,1.13,0,0,0,.43-.53,1,1,0,0,1,1.36-.5,11.41,11.41,0,0,0,2.4.78,1,1,0,0,0,1-.18.9.9,0,0,0-.06-1.07,1.38,1.38,0,0,0-.31-.28,11,11,0,0,0,6.21,1l0,.39a14.38,14.38,0,0,1-3.56,1.36S358.22,405.2,358.7,405.7Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M325.09,418.9a16.84,16.84,0,0,0,5.07-1.3,1,1,0,0,1,.92.11,9,9,0,0,0,9.43.05,1,1,0,0,1,1.13.06,6.84,6.84,0,0,0,7.68.36,1,1,0,0,1,.94-.1,6.43,6.43,0,0,0,3.83.6,3.51,3.51,0,0,0,2.77-3.34,4.62,4.62,0,0,1-3.48,1.69,4.47,4.47,0,0,1-2.77-1,1,1,0,0,0-1.37,0,4.86,4.86,0,0,1-3.52,1.27,5,5,0,0,1-3.38-1.76,1,1,0,0,0-1.33-.22,8.91,8.91,0,0,1-6.29,1.5,3.62,3.62,0,0,1-2-.83,2.39,2.39,0,0,1-.48-.72,1,1,0,0,0-1.34-.57,9.24,9.24,0,0,1-9.8-.79l0,.06a1.71,1.71,0,0,0,.49.6,7.61,7.61,0,0,0,3,1,1,1,0,0,1,.43,1.77c-.53.42-1.15.91-1.82,1.42A8.71,8.71,0,0,0,325.09,418.9Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M369.67,427.84a13.13,13.13,0,0,1-2,.2,1,1,0,0,0-.83.5,3.34,3.34,0,0,1-3.32,1.82s1.3.22,2.92.56a6.46,6.46,0,0,1-5.46-.41,1,1,0,0,0-1.09.16,8.71,8.71,0,0,1-10.68.36,1,1,0,0,0-1.16,0,8.8,8.8,0,0,1-10.34.1,1,1,0,0,0-1.14,0,7.8,7.8,0,0,1-5.82,1.75,6.19,6.19,0,0,1-3-1.29,1,1,0,0,1,.87-1.76,9.44,9.44,0,0,0,7.76-1.5,1,1,0,0,1,1.36.22,2.16,2.16,0,0,0,.86.64,4.49,4.49,0,0,0,2,.21c2.52-.13,5.16-.5,7.25-2a1,1,0,0,1,1.27.12,6.41,6.41,0,0,0,5.14,1.92,6.73,6.73,0,0,0,4.76-3,1,1,0,0,1,1.26-.35,13.15,13.15,0,0,0,11.76-.66l-1.89,2.07A1,1,0,0,1,369.67,427.84Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M353.58,440.94a1,1,0,0,0-1.25.53,2.81,2.81,0,0,1-1,1.25,4.4,4.4,0,0,1-2.34.63,9.91,9.91,0,0,1-6.2-2,1,1,0,0,0-1.25.11,7.32,7.32,0,0,1-10.77-.21,1,1,0,0,0-1-.31,20.93,20.93,0,0,1-15.87-2.5l-.75.41a2.17,2.17,0,0,0,.19.79c.87,2,7.72,4.13,7.72,4.13a14.88,14.88,0,0,1-1.78.57c1.19.36,2.21.65,2.86.86a7,7,0,0,0,6.38-1,1,1,0,0,1,1.31.06,8.22,8.22,0,0,0,11.71-.06,1,1,0,0,1,1.39,0,8.1,8.1,0,0,0,5.21,2.54,5.36,5.36,0,0,0,5-3,1,1,0,0,1,1.1-.58l.41.07a1,1,0,0,0,.23-2A9.44,9.44,0,0,1,353.58,440.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBanner);
export default __webpack_public_path__ + "static/media/hero-banner.b541e81668bb83c29e3476a875deac8a.svg";
export { ForwardRef as ReactComponent };